var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { LiveRegion, Typography, useAnnounceOnChange } from '@lucidlink/uicore';
import { PII_MASK_CLASS } from '#constants';
// Mount only once the status is known: the first value is the silent baseline
export const StatusAnnouncer = ({ announcement, politeness = 'polite', }) => {
    _react_refresh_temp_2();
    const changedAnnouncement = useAnnounceOnChange(announcement);
    return (_jsx(LiveRegion, { politeness: politeness, children: changedAnnouncement && (_jsx(Typography, { className: PII_MASK_CLASS, kind: "generic", children: changedAnnouncement })) }));
};
_react_refresh_temp_1 = StatusAnnouncer;
$RefreshReg$(_react_refresh_temp_1, "StatusAnnouncer");
_react_refresh_temp_2(StatusAnnouncer, "qOh9xfwW7Fo+nXE5iAgPK+BxkmM=", false, () => [useAnnounceOnChange]);
